import type { CasinoGame } from '@ps/web-casino-types';
import { GADimension } from '@ps/web-core-enums';
import type { Primitive } from 'utility-types';

export const gameDimensions = (
  game: CasinoGame,
  index?: number,
  totalGames = 1
): Record<string, string[] | Primitive> | undefined => ({
  [GADimension.UIElementPosition]: typeof index === 'number' ? index + 1 : undefined,
  [GADimension.GameName]: game.name,
  [GADimension.GameCode]: game.gametype,
  [GADimension.GameTags]: game.tags,
  [GADimension.GameJackpot]: game.jackpot ? game.jackpot.value / 100 : null,
  [GADimension.GamesTotal]: totalGames,
  [GADimension.GameVariantID]: game.variant
});
